// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel.attributeTypeMap;
    }
}
ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel.discriminator = undefined;
ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel.additionalProperties = false;
ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel.attributeTypeMap = [
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "sourceId",
        "baseName": "sourceId",
        "type": "TCSSource"
    },
    {
        "name": "surveyId",
        "baseName": "surveyId",
        "type": "number"
    },
    {
        "name": "questionId",
        "baseName": "questionId",
        "type": "number"
    },
    {
        "name": "answerKey",
        "baseName": "answerKey",
        "type": "number"
    },
    {
        "name": "answerText",
        "baseName": "answerText",
        "type": "string"
    },
];
//# sourceMappingURL=extEnrollmentMoveMemberNumberBySurveyQuestionRequestModel.js.map